import { VApplication } from '@/application';
import { SuppliersPageService } from '../../../services';

const MODULE_NAME = 'profile.machines.states.createSupplier';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.SuppliersPageService') as SuppliersPageService;
};

export const createSupplier = async (context: any, event: any) => {
  const currentState = 'ADD_CREDIT_UNION';
  const method = 'createSupplier';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      const content = await srv.createSupplier(event?.payload);
      console.log('createSupplier content =>', content);
      if (content) {
        return resolve({
          key: 'ADD_CREDIT_UNION_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'add Credit union failed';
        return reject({
          key: 'ADD_CREDIT_UNION_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'ADD_CREDIT_UNION_FAILED',
        value: _msg,
      });
    }
  });
};
